import React from "react";
import Dashboard from "./pages/dashboard";
import Popup from "./components/Popup";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

const App = () => {
  return (
    <AuthProvider>
      <div id="bookmarkMenu" className="relative overflow-x-hidden min-w-96 flex flex-col min-h-screen pb-20 bg-zinc-950 text-zinc-100 selection:dark:bg-slate-100 selection:dark:text-zinc-950 selection:bg-zinc-950 selection:text-zinc-100 app_class">
        <ProtectedRoute>
          <Dashboard />
        </ProtectedRoute>
        {/* <Popup/> */}
      </div>
    </AuthProvider>
  );
};

export default App;
